'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlowConfig = exports.assignPageTitle = exports.assignSteps = exports.assignStepParams = exports.assignStepConfig = exports.assignReferrer = exports.getConfigObject = undefined;

var _isFunction = require('hs-lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _signupProductIntents = require('../../core/constants/signupProductIntents');

var _signupProductIntents2 = _interopRequireDefault(_signupProductIntents);

var _QueryParamsContainer = require('../../core/globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _ConfigDefaults = require('./ConfigDefaults');

var _ConfigDefaults2 = _interopRequireDefault(_ConfigDefaults);

var _FlowFromSignupIntent = require('./FlowFromSignupIntent');

var _FlowFromSignupIntent2 = _interopRequireDefault(_FlowFromSignupIntent);

var _IntentToConfig = require('./IntentToConfig');

var _IntentToConfig2 = _interopRequireDefault(_IntentToConfig);

var _IntentToTitle = require('./IntentToTitle');

var _IntentToTitle2 = _interopRequireDefault(_IntentToTitle);

var _standardStepsParams = require('./standardStepsParams');

var _standardStepsParams2 = _interopRequireDefault(_standardStepsParams);

var _steps = require('./steps');

var _steps2 = _interopRequireDefault(_steps);

var _verifiedStandardStepsParams = require('./verifiedStandardStepsParams');

var _verifiedStandardStepsParams2 = _interopRequireDefault(_verifiedStandardStepsParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getConfigObject = exports.getConfigObject = function getConfigObject(config) {
  return config.default ? config.default : config;
};

var assignReferrer = exports.assignReferrer = function assignReferrer(config) {
  var maybeStateFromOAuthPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _FlowFromSignupIntent2.default.maybeStateFromOAuthPayload();

  var locationOrParamReferrer = window.document.referrer ? window.document.referrer : decodeURIComponent(_QueryParamsContainer2.default.get('preReferrer'));
  var hasOAuthPayloadWithReferrer = maybeStateFromOAuthPayload.hasOwnProperty('referrer');
  var maybeReferrerFromOAuth = maybeStateFromOAuthPayload.referrer;

  return Object.assign({}, config, {
    referrer: hasOAuthPayloadWithReferrer ? maybeReferrerFromOAuth : locationOrParamReferrer
  });
};

var assignStepConfig = exports.assignStepConfig = function assignStepConfig(config) {
  config = (0, _isFunction2.default)(config) ? config() : config;

  // if the flow has no steps set, use standard flow steps
  if (!config.stepsConfig) {
    config.stepsConfig = _steps2.default;
  }

  return config;
};

var assignStepParams = exports.assignStepParams = function assignStepParams(config) {
  if (!config.stepsParams) {
    config.stepsParams = config.isVerified === true ? _verifiedStandardStepsParams2.default : _standardStepsParams2.default;
  }

  return config;
};

var assignSteps = exports.assignSteps = function assignSteps(config) {
  var stepsCfg = config.stepsConfig(config.stepsParams, config.appName).getSteps();

  // extend base config with obtained steps
  config = Object.assign({ steps: stepsCfg }, config);

  // merge flow config with eventual additional defaults
  return Object.assign(_ConfigDefaults2.default, config);
};

var assignPageTitle = exports.assignPageTitle = function assignPageTitle(config) {
  if (_IntentToTitle2.default.hasOwnProperty(config.setupProductName)) {
    _I18n2.default.title('core.titleWithProduct', {
      product: _IntentToTitle2.default[config.setupProductName]
    });
  } else {
    _I18n2.default.title('core.title');
  }

  return config;
};

var getFlowConfig = exports.getFlowConfig = function getFlowConfig() {
  var signupIntent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _FlowFromSignupIntent2.default.getSelectedFlow();

  var getDynamicConfig = _IntentToConfig2.default[signupIntent];

  if (!getDynamicConfig) {
    LOG.warn("Couldn't get signup config, defaulting to crm");
    getDynamicConfig = _IntentToConfig2.default[_signupProductIntents2.default.crm];
  }

  return getDynamicConfig().then(getConfigObject).then(assignPageTitle).then(assignStepConfig).then(assignStepParams).then(assignSteps).then(assignReferrer);
};